import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { AUTH_SERVICE } from '@awp/http';
import { AuthService1 } from './api/auth.service';

@NgModule({
  imports: [CommonModule, HttpClientModule]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        {
          provide: AUTH_SERVICE,
          useClass: AuthService1
        }
      ]
    };
  }
}
